<script setup>
  import { computed, inject } from 'vue'
  import AddRounds from '../TournamentForm/AddRounds.vue';
  import RoundCard from './RoundCard.vue';

  const editMode = inject('editMode')

  const group = defineModel()

  // Trova il primo round con state = 'scheduled'
  const upcomingRound = computed(() => {
    if (!group.value.rounds || group.value.rounds.length === 0) return null
    return group.value.rounds
      .sort((a, b) => a.round_number - b.round_number)
      .find(round => round.state === 'scheduled' || round.state === 'running')
  })

  // Indice dell'ultimo round con state = 'completed'
  const lastCompletedIndex = computed(() => {
    const rounds = group.value.rounds.sort((a, b) => a.round_number - b.round_number) || []
    for (let i = rounds.length - 1; i >= 0; i--) {
      if (rounds[i] && rounds[i].state === 'completed') return i
    }
    return -1
  })

  // Computed scrivibile per l'ultimo round completato (get + set)
  const lastCompletedRound = computed({
    get() {
      const i = lastCompletedIndex.value
      if (i === -1) return null
      return group.value.rounds[i]
    },
    set(value) {
      const i = lastCompletedIndex.value
      if (i === -1) return
      // Aggiorna in-place per mantenere la reattività dell'array
      Object.assign(group.value.rounds[i], value)
    }
  })
</script>


<template>
  <v-row>
    <v-col cols="12" md="6" class="d-flex">
      <RoundCard v-if="lastCompletedRound" v-model="lastCompletedRound" class="flex-grow-1" />
    </v-col>
    <v-col cols="12" md="6" class="d-flex">
      <RoundCard v-if="upcomingRound" v-model="upcomingRound" class="flex-grow-1" />
    </v-col>
  </v-row>

  <div v-if="!group.rounds || group.rounds.length == 0">
    <v-alert
      type="info"
      variant="text"
      class="my-8"
    >
      {{ $t('tournaments.noRounds') }}
    </v-alert>
  </div>

  <div v-if="editMode" class="d-flex justify-center mt-8">
    <AddRounds
      v-model="group"
    />
  </div>

</template>